
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { REG_HUB_COMMON_CONFIG, RegHubCommonConfig } from '../../reg-hub-common-config';
import { PaginatedRepository } from '../pagination/paginated.repository';
import { AttestationTemplate } from '../../interfaces/attestation-templates/attestation-template';
import { AttestationTemplateForCreation } from '../../interfaces/attestation-templates/attestation-template-for-creation';
import { AttestationTemplateForUpdate } from '../../interfaces/attestation-templates/attestation-template-for-update';
import { SelectOption } from '../../interfaces/select-option';


@Injectable({
  providedIn: 'root'
})
export class AttestationTemplateRepositoryService extends PaginatedRepository<AttestationTemplate> {
  protected _baseLink: string;

  constructor(
    @Inject(REG_HUB_COMMON_CONFIG) private config: RegHubCommonConfig,
    http: HttpClient,
    messageService: ToastrService) {
    super(
      http,
      messageService);

    this._baseLink = `${config.rootUrl}/attestationTemplates`;
  }

  private generateHeaders = () => {
    return {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
  };

  public getAttestationTemplate = (attestationTemplateID: string) => {
    return this.http.get<AttestationTemplate>(`${this._baseLink}/${attestationTemplateID}`);
  };

  public getAttestationTemplates(params?: HttpParams): Observable<AttestationTemplate[]> {
    let requestParams = params ?? new HttpParams().set('PageSize', 100);
    return this.http.get<AttestationTemplate[]>(this._baseLink, { params: params ?? requestParams });
  }

  public getAttestationTemplatesAsSelectOptions(params?: HttpParams): Observable<SelectOption[]> {
    return this.getAttestationTemplates(params).pipe(map(types => types.map(this.mapAttestationTemplatesToSelectOption)));
  }

  private mapAttestationTemplatesToSelectOption(template: AttestationTemplate): SelectOption {
    return { label: template.name, value: template.id };
  }

  public createAttestationTemplate = (attestationTemplateForCreation: AttestationTemplateForCreation) => {
    return this.http.post<AttestationTemplate>(
      this._baseLink,
      attestationTemplateForCreation,
      this.generateHeaders());
  };

  public updateAttestationTemplate = (attestationTemplateID: string, attestationTemplate: AttestationTemplateForUpdate) => {
    return this.http.put(`${this._baseLink}/${attestationTemplateID}`, attestationTemplate, this.generateHeaders());
  };

  public deleteAttestationTemplate = (attestationTemplateID: string) => {
    return this.http.delete(`${this._baseLink}/${attestationTemplateID}`);
  };
}
